import React from 'react';
import Select from 'react-select';

export default props => {
  const sortFileds = [
    { label: locales('fields.createdAt'), value: 'createdAt' },
    { label: locales('labels.score'), value: 'score' },
    { label: locales('fields.cafe.name'), value: 'cafeName' },
    { label: locales('fields.comment.sender.name'), value: 'userFullName' },
    { label: locales('labels.last.reviewed.at'), value: 'lastReviewedAt' }
  ];

  return (
    <div className="col-12 d-flex align-items-center">
      <Select
        placeholder={locales('messages.sortBy')}
        isMulti={false}
        name="sort"
        value={props.selectedSortFiled}
        options={sortFileds}
        onChange={props.onChangeSortBy}
        className="w-25"
      />

      <label className="mx-2">
        {locales('tables.desc')}
        <input
          type="radio"
          name="sortDirection"
          className="mx-2"
          onChange={() => props.setSortDirection('desc')}
          checked={props.sortDirection == 'desc'}
        />
      </label>

      <label className="mx-2">
        {locales('tables.asc')}
        <input
          type="radio"
          name="sortDirection"
          className="mx-2"
          onChange={() => props.setSortDirection('asc')}
          checked={props.sortDirection == 'asc'}
        />
      </label>

      <button
        disabled={!props.selectedSortFiled}
        onClick={props.onSort}
        className="btn btn-primary"
      >
        {locales('tables.sortIt')}
      </button>
    </div>
  );
};
